import { render, staticRenderFns } from "./FiltroDuo.vue?vue&type=template&id=cbe50d76"
import script from "./FiltroDuo.vue?vue&type=script&lang=js"
export * from "./FiltroDuo.vue?vue&type=script&lang=js"
import style0 from "./FiltroDuo.vue?vue&type=style&index=0&id=cbe50d76&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports